module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_nordland_pos.25526b49.png";